module.exports = __webpack_public_path__ + "img/select.4d0e1a7e.svg";